import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";

export type IncidentRecord = NonNullable<
  ResultOf<typeof incidentRecordQuery>["incident"]
>;

export type IncidentPhoto = IncidentRecord["photos"][number];

export const incidentRecordQuery = graphql(`
  query IncidentRecord($id: ID!) {
    incident(id: $id) {
      id
      reference
      status
      closed_outcome
      found_at
      type
      description
      currency
      follow_up_contact
      insurer
      claim_reference
      excess_amount
      claim_opened_at
      rejection_reason
      claimDocuments {
        ...MediaFields
      }
      workOrderAssignment {
        id
        pickup_date
        delivery_date
        driver_pick_up_at
        driver_delivered_at
      }
      workOrder {
        id
        reference
        vehicle_type
        relocation {
          id
          vehicle {
            id
            brand
            model
          }
        }
        departureAddress {
          id
          formatted_address_line_1
        }
        deliveryAddress {
          id
          formatted_address_line_1
        }
      }
      proDriver {
        id
        name
        email
        phone
        license_number
        license_issuer
        license_type
      }
      supplier {
        id
        name
      }
      photos {
        ...MediaFields
      }
      departureImages {
        ...MediaFields
      }
      deliveryImages {
        ...MediaFields
      }
    }
  }
`);
